import Marquee from "react-fast-marquee";
import { Sparkle } from "@phosphor-icons/react";

const ITEMS = [
  "SELL YOUR PHONE",
  "SELL YOUR MACBOOK",
  "SELL YOUR IPAD",
  "SELL YOUR WATCH",
  "SELL YOUR PS5",
  "SELL YOUR XBOX",
  "SEALED ELECTRONICS",
  "WORKING DEVICES ONLY",
];

export const EditorialMarquee = () => (
  <div className="overflow-hidden border-y border-black/10 bg-white py-5" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((t) => (
        <span
          key={t}
          className="mx-10 flex items-center gap-10 font-display text-sm font-semibold uppercase tracking-[0.3em] text-navy"
        >
          {t}
          <Sparkle size={12} weight="fill" className="text-brand" />
        </span>
      ))}
    </Marquee>
  </div>
);
